import script from "./DesktopHeader.vue?vue&type=script&setup=true&lang=ts"
export * from "./DesktopHeader.vue?vue&type=script&setup=true&lang=ts"

import "./DesktopHeader.vue?vue&type=style&index=0&id=c18727ec&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c18727ec"]])

export default __exports__